import React from 'react';
import EditBetSlip from './EditBetSlip';

const ConfirmBetSlip = () => {
    return (
        <EditBetSlip isFinal={true}></EditBetSlip>
    );
};

export default ConfirmBetSlip;